import { Injectable, Injector } from '@angular/core'
import { APIService } from 'api/module'
import { AIAnnotation, AIDataset, AssetMini, Proxy } from 'elements-sdk'

export interface AIRectangle {
  relativeLeft: number
  relativeTop: number
  relativeWidth: number
  relativeHeight: number
}

@Injectable({ providedIn: 'root' })
export class AIService {
  constructor (
    private api: APIService,
    private injector: Injector,
  ) { }

  async createMetadata (
    asset_ids: number[]|null,
    directory_ids: number[]|null,
    datasets: AIDataset[],
    preferred_proxy_profile: number,
  ): Promise<void> {
    await this.api.ai.createAIMetadata({
      aIProcessingRequest: {
        assets: asset_ids ?? [],
        directories: directory_ids ?? [],
        datasets: datasets.map(x => x.id),
        preferredProxyProfile: preferred_proxy_profile,
      },
    })
  }

  async track (categoryId: string, proxyId: number, frame: number, rectangle: AIRectangle): Promise<AIAnnotation[]> {
    return this.api.ai.createAIAnnotationTrack({
      aIAnnotationCreateRequest: {
        category: categoryId,
        proxy: proxyId,
        frame,
        ...rectangle,
      },
    })
  }

  async openMarkupModal (asset: AssetMini, proxy: Proxy, frame: number): Promise<void> {
    await this.injector.get('$injector').get('$uibModal').open({
      component: 'ai-markup-modal',
      size: 'ai-markup-modal',
      resolve: {
        asset: () => asset,
        proxy: () => proxy,
        frame: () => frame,
      },
    }).result
  }

  getAnnotationImageURL (annotation: AIAnnotation): string {
    return `/api/2/ai/annotations/${annotation.id}/image`
  }
}
